import { useEffect, useRef } from "react";

const ElementEvent: any = global;

export function useEventListener(type: string, handler: Function) {
  const savedHandler = useRef<Function>(null);
  const listenerAdded = useRef<boolean>(false);

  useEffect(() => {
    const isSupported =
      ElementEvent && typeof ElementEvent.addEventListener === "function";
    if (!isSupported) {
      throw new Error("Event Listener is not supported");
    }

    if (!savedHandler.current) {
      savedHandler.current = handler;
    }

    if (!listenerAdded.current) {
      ElementEvent.addEventListener(type, handleEvent);
      listenerAdded.current = true;
    }

    return () => {
      if (listenerAdded.current) {
        if (
          ElementEvent &&
          typeof ElementEvent.removeEventListener === "function"
        ) {
          ElementEvent.removeEventListener(type, handleEvent);
        }
        listenerAdded.current = false;
      }
    };
  }, [type, handler]);

  function handleEvent(e: CustomEvent) {
    e.preventDefault();
    savedHandler.current!(e.detail);
  }
}

export function eventDispatcher(key: string, payload: any = null) {
  ElementEvent.dispatchEvent(new CustomEvent(key, { detail: payload }));
}
